__turbopack_context__.v({
  "container": "ErrorView-module-scss-module__kWV6OG__container",
  "footerActions": "ErrorView-module-scss-module__kWV6OG__footerActions",
});
